/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgListComponents = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <style>{'.ico-list-components_svg__st0{fill:currentcolor}'}</style>
    <path
      className="ico-list-components_svg__st0"
      d="M13 16c-1.7 0-3 1.3-3 3s1.3 3 3 3 3-1.3 3-3-1.3-3-3-3zm0 4c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"
    />
    <path
      className="ico-list-components_svg__st0"
      d="M19 14V5H7V2H5v3H2v2h3v12h3v-2H7V7h10v7zm-1 4h4v2h-4z"
    />
  </Icon>
);
export { SvgListComponents as ListComponents };
